import React, {useCallback, useEffect, useRef, useState} from "react";
import "./loginProviders.scss";
import {Button, Divider} from "antd";
import {FaApple} from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";
import {createNonce, decodeJwt, LoginExternalnUser} from "../../utils/AuthFunctions";
import {LoginProviderTypes} from "../../enums/LoginProviderTypes";
import {useSelector} from "react-redux";
import {useHistory} from "react-router-dom";

export const LoginProviders  = ({setMsg, textDivider}) => {
  const accountSettings = useSelector((state) => state.accountSettings);
  const appleNonceRef = useRef("");
  const googleNonceRef = useRef("");
  const history = useHistory();
  const [showOneTap, setShowOneTap] = useState(true);
  const redirectURI = `${window.location.origin}/home`;
  /* Sign in with Apple  */
  const initApple = useCallback(async () => {
    if (document.getElementById("appleid-auth-js")) return;

    const script = document.createElement("script");
    script.id = "appleid-auth-js";
    script.src =
      "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/es_MX/appleid.auth.js";
    script.async = true;
    script.onload = async () => {
      if (window.AppleID?.auth) {
        const nonce = await createNonce();
        appleNonceRef.current = nonce;
        window.AppleID.auth.init({
          clientId: process.env.REACT_APP_APPLE_CLIENTID,
          scope: "name email",
          redirectURI: redirectURI,
          usePopup: true,
          nonce,
          response_type: "code id_token",
          response_mode: "fragment"
        });
      }
    };
    document.body.appendChild(script);
  }, []);

  useEffect(() => { initApple(); }, [initApple]);

  const handleLoginApple = async () => {
    try {
      const response = await window.AppleID.auth.signIn();
      const { authorization, user } = response || {};
      const idToken = authorization?.id_token || "";
      const code = authorization?.code || "";
      const claims = decodeJwt(idToken);

      const firstName = user?.name?.firstName || "";
      const lastName = user?.name?.lastName || "";
      const params = {
        username: claims?.email || "",
        password: "",
        productSubscription: accountSettings.productSubscription,
        provider: LoginProviderTypes.APPLE,
        idToken,
        code,
        nonce: appleNonceRef.current || "",
        firstName,
        lastName
      };

      const logged = await LoginExternalnUser(params);

      if (logged) {
        if (logged.roleName === "Operaciones") history.push("/operator");
        if (logged.responseCode === "11") {
          history.push({ pathname: "/membership", state: logged });
        }
        window.location.reload();
      }
    } catch (err) {
      console.error("Apple error:", err);
      setMsg("No se pudo completar el inicio de sesión con Apple.");
    }
  };

  /* GOOGLE */
  const onGoogleCredential = async ({ credential }) => {
    try {
      const claims = decodeJwt(credential);
      const params = {
        username: claims?.email || "",
        password: "",
        productSubscription: accountSettings.productSubscription,
        provider: LoginProviderTypes.GOOGLE,
        idToken: credential,
        code: "",
        nonce: googleNonceRef.current || "",
        firstName: claims?.given_name || "",
        lastName: claims?.family_name || "",
        profilePicture: claims?.picture || ""
      };

      const logged = await LoginExternalnUser(params);

      if (logged) {
        if (logged.roleName === "Operaciones") history.push("/operator");
        if (logged.responseCode === "11") {
          history.push({ pathname: "/membership", state: logged });
        }
        window.location.reload();
      }
    } catch (err) {
      console.error("Google login error:", err);
      setMsg("No se pudo completar el inicio de sesión con Google.");
    }
  };

const googleInitOnce = useRef(false);

const initGoogle = useCallback(async () => {
  if (googleInitOnce.current) return;
  googleInitOnce.current = true;

  const ensureInit = async () => {
    if (window.google?.accounts?.id) {
      if (!googleNonceRef.current) googleNonceRef.current = await createNonce();

      window.google.accounts.id.initialize({
        client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
        nonce: googleNonceRef.current,
        callback: onGoogleCredential,
        auto_select: false,
        cancel_on_tap_outside: false,
        prompt_parent_id: "gsi-parent",
        use_fedcm_for_prompt: true
      });
    }
  };

  const exists = document.getElementById("gsi-client");
  if (exists) { ensureInit(); return; }

  const script = document.createElement("script");
  script.id = "gsi-client";
  script.src = "https://accounts.google.com/gsi/client";
  script.async = true;
  script.defer = true;
  script.onload = ensureInit;
  document.body.appendChild(script);
}, [onGoogleCredential]);

useEffect(() => { initGoogle(); }, [initGoogle]);

const handleLoginGoogle = () => {
  if (window.google?.accounts?.id) {
    window.google.accounts.id.prompt((notification) => {
      if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
        setShowOneTap(false);
        window.google.accounts.id.renderButton(
          document.getElementById("g_id_signin"),
          { theme: "outline", size: "large" }
        );
      }
    });
  } else {
    setMsg("Google aún no está listo. Intenta de nuevo en unos segundos.");
  }
};

  return(
    <>
      <Divider>{textDivider}</Divider>

      <div className="form-light__footer center">
              
        <Button
          icon={<FaApple />}
          htmlType="button"
          onClick={handleLoginApple}
          shape="circle"
          type="default"
          className={"apple"}
          size={"small"}
        />
        {showOneTap &&
        <Button
          icon={<FcGoogle />}
          htmlType="button"
          onClick={handleLoginGoogle}
          shape="circle"
          type="default"
          className={"google"}
          size={"small"}
          aria-label="Ingresar con Google"
        />}
        <div id="g_id_signin"></div>
      </div>
    </>
  )
}
